// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FolderViewOutlinedSvg from "@ant-design/icons-svg/es/asn/FolderViewOutlined";
import AntdIcon from '../components/AntdIcon';

var FolderViewOutlined = function FolderViewOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FolderViewOutlinedSvg
  }));
};

FolderViewOutlined.displayName = 'FolderViewOutlined';
export default React.forwardRef(FolderViewOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FolderViewOutlined.js
// module id = 1205
// module chunks = 0